import {JobUpdateRequest} from '../models/pos/jobUpdate.request';
import {JobType} from '../models/pos/jobType.model';
import {JobTransformRequest} from '../models/pos/jobTransform.request';

export namespace Pos {
  export class GetJobs {
    static readonly type = '[Pos api] GetJobs';

    constructor(public type: JobType, public force: boolean = false) {
    }
  }

  export class GetJob {
    static readonly type = '[Pos api] GetJob';

    constructor(public id: string, public type: JobType, public force: boolean = false) {
    }
  }

  export class CreateJob {
    static readonly type = '[Pos api] CreateJob';

    constructor(public type: JobType) {
    }
  }

  export class ReopenJob {
    static readonly type = '[Pos api] ReopenJob';

    constructor(public id: string, public type: JobType) {
    }
  }

  export class CloseJob {
    static readonly type = '[Pos api] CloseJob';

    constructor(public id: string, public type: JobType) {
    }
  }

  export class LockJob {
    static readonly type = '[Pos api] LockJob';

    constructor(public id: string, public type: JobType) {
    }
  }

  export class UnlockJob {
    static readonly type = '[Pos api] UnlockJob';

    constructor(public id: string, public type: JobType) {
    }
  }

  export class UpdateJob {
    static readonly type = '[Pos api] UpdateJob';

    constructor(public id: string, public type: JobType, public request: JobUpdateRequest) {
    }
  }

  export class TransformJob {
    static readonly type = '[Pos api] Transform Job';

    constructor(public request: JobTransformRequest) {
    }
  }

  export class ClearCurrentJob {
    static readonly type = '[Pos api] Clear Current Job';

    constructor(public type: JobType) {
    }
  }
}
